angular
  .module('jrEvents', [])
  .constant('EventsConstants', {
    searchFormModelChanged: 'searchFormModel:changed',
    validatiorError: 'validation:error',
    validationReset: 'validation:reset',
    inlineProposalActivated: 'inlineProposal:activated',
    inlineProposalDeactivated: 'inlineProposal:deactivated',
    subscriptionProposal: 'subscription:proposal',
    subscriptionSkipped: 'subscription:skipped',
    subscriptionSent: 'subscription:sent',
    navigationLinksToggle: 'navigationLinks:toggle',
    footerCheckFixable: 'checkFooterFixable',
    tmsWidgetLoaded: 'tmsWidgetLoaded',
    singleOptInSubscriptionConfirmed: 'singleOptInSubscriptionConfirmed',
    subscriptionSentWhenApplyShowMoreFlowIsEnabled:
      'subscriptionSentWhenApplyShowMoreFlowIsEnabled',
  })
  .factory('EventsService', [
    'EventsConstants',
    '$rootScope',
    '$timeout',
    function (EventsConstants, $rootScope, $timeout) {
      function emit(eventName) {
        return function (data) {
          /*
           * see:
           * http://stackoverflow.com/questions/20610450/angulajs-angularjs-timeout-without-delay-parameters-reason
           */
          $timeout(function () {
            $rootScope.$emit(eventName, data);
          });
        };
      }

      function on(eventname) {
        return function (callback) {
          $rootScope.$on(eventname, callback);
        };
      }

      const eventsServiceEmit = {};
      const eventsServiceOn = {};

      angular.forEach(EventsConstants, function (eventName, eventKey) {
        eventsServiceEmit[eventKey] = emit(eventName);
        eventsServiceOn[eventKey] = on(eventName);
      });

      return {
        emit: eventsServiceEmit,
        on: eventsServiceOn,
      };
    },
  ]);
